export const combinedproviders= [
  { providername: "Dr.Madhu/Oco" },
  { providername: "Dr.Madhu/Jaime" },
  { providername: "NotAssigned" },
  { providername: "Dr.Madhu/Duke" },
  { providername: "Dr.Duke / Jaime" },
  { providername: "Dr. Duke/Oco" },
 
  { providername: "Dr.Madhu/Leanora" },
  { providername: "Dr.Madhu/Sadiq" },
  { providername: "Dr.Madhu/Lena" },

];
